<template>
  <v-app>
    <v-main>
      <Navbar />
      <ConfirmDialog ref="confirm" />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "./components/core/Navbar.vue";
import ConfirmDialog from "./components/core/ConfirmDialog.vue";

export default {
  name: "App",
  components: {
    Navbar,
    ConfirmDialog,
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;
  },
};
</script>
